export default __webpack_public_path__ + "static/media/instructions.779e6f9b.svg";